import React, { useState } from 'react';
import CollapsableCard from 'src/common/refactoredComponents/collapsableCard/CollapsableCard.jsx';
import edit from 'src/assets/images/Edit.svg';
import { makeStyles } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { Type, Data, StyledDiv, LineSeparator, DataContainer, QuantityContainer } from './Replenishment.styled';
import SelectedShipToAddressLabel from 'src/common/components/selectedShipToAddressLabel/SelectedShipToAddressLabel';
import { StyledShippingDetails } from 'src/pages/reportUsage/replen/components/replenListView/replenListViewDesktop/RowTemplateDesktop';
import { MainContainerItems } from 'src/pages/reportUsage/record/components/changeAccount/AccountSection.styled';
import { Title } from 'src/pages/reportUsage/procedure/components/Procedure.styled';
import { getDisplayDate } from 'src/utils/dateUtils';
import { Subtitle } from 'src/common/components/orderDetails/trackingNumberLabel/TrackingNumberLabel.styled';
import useWindowSize from './../../../../../common/components/getWindowSize';
import { sizes } from 'src/styles/Media.styled';
import { useTranslation } from 'react-i18next';
import { VISIBLE } from 'src/constants/appConstants';
const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    paper: {
        padding: theme.spacing(2),
        // margin: 'auto',
        // maxWidth: 500,
    },
    image: {
        width: 128,
        height: 128,
    },
    img: {
        margin: 'auto',
        display: 'block',
        maxWidth: '100%',
        maxHeight: '100%',
    },
    gridPadBottom: {
        paddingBottom: 8,
    },
}));
const ReplenishmentCard = ({ replenGridData, navigateToSpecifiedScreen }) => {
    const [expandedCard, setExpandedCard] = useState({
        replenishment: false,
    });
    const classes = useStyles();
    const { replenishment } = expandedCard;
    const toggleCard = (name, value) => {
        setExpandedCard({
            ...expandedCard,
            [name]: value,
        });
    };

    const { t } = useTranslation();

    const usageOrderSubmission = useSelector(
        (state) => state.reportUsageRootReducer.usageOrderSubmission
    );

    const restrictReviewScreen = useSelector(
        (state) => state.reportUsageRootReducer.restrictReviewScreen
    );

    const isSubmitClicked = useSelector(
        (state) => state.reportUsageRootReducer.isSubmitClicked
    );

    const orderStatus = useSelector(
        (state) => state.reportUsageRootReducer.orderStatus
    );

    const usageReplenishmentSurgeryDateVisibility = useSelector(
        (state) => state.loginReducer.usageReplenishmentSurgeryDateVisibility
    );

    const isUsagedSubmittedSuccessfully =
        (usageOrderSubmission && usageOrderSubmission.statusCode === '200') ||
        (Object.keys(orderStatus).length > 0 &&
            orderStatus.status &&
            orderStatus.status.includes('Usage Order Submitted Successfully'));

    const totalReplenQty =
        replenGridData &&
        replenGridData.reduce(
            (acc, curr) => acc + parseInt(curr.newReplenQty || curr.replenQty),
            0
        );
    return (
        <div style={{ marginBottom: '10px', marginTop: '10px' }}>
            <CollapsableCard id="reportUsage-replenishment-review-orderTypesReplenishment"
                title={`${t('orders.orderTypes.replenishment')} (${
                    totalReplenQty ? totalReplenQty : 0
                })`}
                onClick={() => toggleCard('replenishment', !replenishment)}
                isExpanded={replenishment}
                editButton={
                    isUsagedSubmittedSuccessfully ||
                    isSubmitClicked ||
                    !restrictReviewScreen
                        ? null
                        : edit
                }
                editPage={() => navigateToSpecifiedScreen('Replen')}
                noCardData={totalReplenQty === 0}
            >
                {replenishment && (
                    <>
                        {replenGridData &&
                            replenGridData.map((item) => (
                                <Box
                                    key={item.index}
                                    className={classes.paper}
                                    my={1}
                                    bgcolor={'#ffffff'}
                                    boxShadow={2}
                                    borderRadius={6}
                                >
                                    <StyledDiv
                                        desktopDisplay={'flex'}
                                        display={'unset'}
                                        desktopJustifyContent={'space-between'}
                                    >
                                        <StyledDiv
                                            desktopWidth={'35%'}
                                            width={'100%'}
                                            // justifyContent={'space-between'}
                                            // desktopJustifyContent={
                                            //     'space-between'
                                            // }
                                            desktopDisplay={'flex'}
                                            display={'flex'}
                                            // style={{ display: 'flex' }}
                                        >
                                            <DataContainer>
                                                <Data>{item.cfn}</Data>
                                                <Data
                                                    color={'#000000'}
                                                    fontSize={'13px'}
                                                    fontFamily={
                                                        'AvenirNextWorld Regular'
                                                    }
                                                    margin={'0 0 15px 0'}
                                                >
                                                    {item.description}
                                                </Data>
                                            </DataContainer>
                                            <QuantityContainer>
                                                <StyledDiv desktopWidth={'20%'}>
                                                    {item.newReplenQty ||
                                                        item.replenQty}
                                                    x<Type>{item.uom}</Type>
                                                </StyledDiv>
                                            </QuantityContainer>
                                        </StyledDiv>
                                        <LineSeparator />
                                        <StyledDiv
                                            desktopWidth={'35%'}
                                            width={'100%'}
                                        >
                                            {item.shippingDetails &&
                                                item.shippingDetails
                                                    .shippingAddress && (
                                                    <>
                                                        <Data
                                                            color={'#202124'}
                                                            fontSize={'14px'}
                                                            margin={
                                                                '15px 0 0 0'
                                                            }
                                                        >
                                                            {t(
                                                                'reportUsage.replen.replenListView.shippingAddress'
                                                            )}
                                                        </Data>
                                                        {item.shippingDetails
                                                            ?.attnLine && (
                                                            <StyledShippingDetails>
                                                                {t(
                                                                    'reportUsage.replen.replenListView.attn'
                                                                )}{' '}
                                                                {
                                                                    item
                                                                        .shippingDetails
                                                                        .attnLine
                                                                }
                                                            </StyledShippingDetails>
                                                        )}
                                                        {Object.keys(
                                                            item
                                                                ?.shippingDetails
                                                                ?.transferRecipient
                                                        ).length > 0 && (
                                                            <StyledShippingDetails>
                                                                {t(
                                                                    'reportUsage.replen.selectShipToAddress.transferRecipient'
                                                                )}
                                                                :{' '}
                                                                {
                                                                    item
                                                                        ?.shippingDetails
                                                                        ?.transferRecipient
                                                                        ?.city
                                                                }
                                                            </StyledShippingDetails>
                                                        )}
                                                        <Data
                                                            color={'#202124'}
                                                            fontSize={'15px'}
                                                            fontFamily={
                                                                'AvenirNextWorld Regular'
                                                            }
                                                            margin={
                                                                '0 0 20px 0'
                                                            }
                                                        >
                                                            <SelectedShipToAddressLabel
                                                                address={
                                                                    item
                                                                        .shippingDetails
                                                                        .shippingAddress
                                                                }
                                                            />
                                                        </Data>
                                                        {item?.shippingDetails
                                                            ?.careOfField && (
                                                            <StyledShippingDetails>
                                                                {t(
                                                                    'consignmentBilling.replen.replenListView.replenListViewDesktop.Careof'
                                                                )}{' '}
                                                                {
                                                                    item
                                                                        ?.shippingDetails
                                                                        ?.careOfField
                                                                }
                                                            </StyledShippingDetails>
                                                        )}
                                                    </>
                                                )}
                                        </StyledDiv>
                                        {Object.keys(
                                            item?.shippingDetails
                                                ?.transferRecipient
                                        ).length > 0 && (
                                            <StyledDiv
                                                desktopWidth={'35%'}
                                                width={'100%'}
                                            >
                                                <Data
                                                    color={'#202124'}
                                                    fontSize={'14px'}
                                                    margin={'15px 0 0 0'}
                                                >
                                                    {t(
                                                        'reportUsage.replen.selectShipToAddress.transferRecipient'
                                                    )}
                                                </Data>
                                                <Data
                                                    color={'#202124'}
                                                    fontSize={'15px'}
                                                    fontFamily={
                                                        'AvenirNextWorld Regular'
                                                    }
                                                    margin={'0 0 20px 0'}
                                                >
                                                    <SelectedShipToAddressLabel
                                                        address={
                                                            item
                                                                ?.shippingDetails
                                                                ?.transferRecipient
                                                        }
                                                    />
                                                </Data>
                                            </StyledDiv>
                                        )}
                                        <StyledDiv desktopWidth={'20%'}>
                                            {item.shippingDetails &&
                                                item.shippingDetails
                                                    .shippingMethod
                                                    .shippingMethodName && (
                                                    <>
                                                        <Data
                                                            color={'#202124'}
                                                            fontSize={'14px'}
                                                        >
                                                            {t(
                                                                'reportUsage.replen.replenListView.shippingMethod'
                                                            )}
                                                        </Data>
                                                        <Data
                                                            color={'#202124'}
                                                            fontSize={'15px'}
                                                            fontFamily={
                                                                'AvenirNextWorld Regular'
                                                            }
                                                        >
                                                            {
                                                                item
                                                                    .shippingDetails
                                                                    .shippingMethod
                                                                    .shippingMethodName
                                                            }
                                                        </Data>
                                                    </>
                                                )}
                                            {item.shippingDetails &&
                                                usageReplenishmentSurgeryDateVisibility ===
                                                    VISIBLE &&
                                                item.shippingDetails
                                                    ?.surgeryDate && (
                                                    <>
                                                        <Data
                                                            color={'#202124'}
                                                            fontSize={'14px'}
                                                        >
                                                            {t(
                                                                'common.surgeryDateLabel'
                                                            )}
                                                        </Data>
                                                        <Data
                                                            color={'#202124'}
                                                            fontSize={'15px'}
                                                            fontFamily={
                                                                'AvenirNextWorld Regular'
                                                            }
                                                        >
                                                            {item
                                                                .shippingDetails
                                                                ?.surgeryDate
                                                                ? getDisplayDate(
                                                                      item
                                                                          .shippingDetails
                                                                          .surgeryDate
                                                                  )
                                                                : ''}
                                                        </Data>
                                                    </>
                                                )}
                                            {item.shippingDetails &&
                                                item.shippingDetails
                                                    .requestDeliveryDate && (
                                                    <>
                                                        <Data
                                                            color={'#202124'}
                                                            fontSize={'14px'}
                                                        >
                                                            {t(
                                                                'common.requestedDeliveryDateLabel'
                                                            )}
                                                        </Data>
                                                        <Data
                                                            color={'#202124'}
                                                            fontSize={'15px'}
                                                            fontFamily={
                                                                'AvenirNextWorld Regular'
                                                            }
                                                        >
                                                            {item
                                                                .shippingDetails
                                                                .requestDeliveryDate
                                                                ? getDisplayDate(
                                                                      item
                                                                          .shippingDetails
                                                                          .requestDeliveryDate
                                                                  )
                                                                : ''}
                                                        </Data>
                                                    </>
                                                )}
                                        </StyledDiv>
                                    </StyledDiv>
                                </Box>
                            ))}
                    </>
                )}
            </CollapsableCard>
        </div>
    );
};

export default ReplenishmentCard;
